enum OrderOptimizerRailyListingFilterType {
  ORDER_HUMAN_ID = "ORDER_HUMAN_ID",
  MAXIMUM_DELAY = "MAXIMUM_DELAY",
  MAXIMUM_HALTING_TIME = "MAXIMUM_HALTING_TIME",
  IGNORE_DRIVER_ROUTES = "IGNORE_DRIVER_ROUTES",
  IGNORE_TAXI = "IGNORE_TAXI",
  IGNORE_ONLY_WITH_TAXI = "IGNORE_ONLY_WITH_TAXI",
  IGNORE_CARGO = "IGNORE_CARGO",
  IGNORE_ONLY_WITH_CARGO = "IGNORE_ONLY_WITH_CARGO",
  STATUS = "STATUS",
}

export default OrderOptimizerRailyListingFilterType;
